import { Component, OnInit, Input, Inject } from '@angular/core';
import { FormBuilder, FormGroup, FormControl, Validators } from '@angular/forms';
import { MatDialog, MAT_DIALOG_DATA, MatDialogRef } from '@angular/material/dialog';

import { UserEntryDialogService } from './UserEntryDialogService';
import { AbstractComponent } from '../../../../../../../core/common/component/AbstractComponent';

@Component({
  selector: 'user-entry-dialog',
  templateUrl: './UserEntryDialog.html',
  styleUrls: ['./UserEntryDialog.scss'],
})
export class UserEntryDialogComponent extends AbstractComponent {
  params;
  registerForm: FormGroup;

  scope = {
    message : '',
    isEdit : false
  }

  constructor(
    @Inject(MAT_DIALOG_DATA) public parameter: any,
              private service : UserEntryDialogService,
              private matDialogRef : MatDialogRef<UserEntryDialogComponent>,
              private formBuilder: FormBuilder,
    ) {
    super();
    this.params = this.parameter;
    // this.toasterService = toasterService;
  }
  public componentWillMount() {
    if (this.params.user) {
      this.scope.isEdit = true;
    }
    this.registerForm = this.formBuilder.group({
      email: new FormControl({value: '', disabled: this.scope.isEdit }, [Validators.required, Validators.email]),
      familyName: new FormControl('', Validators.required),
      firstName: new FormControl('', Validators.required),
      position: new FormControl(''),
      deleteFlg: new FormControl('')
    });
    if (this.scope.isEdit) {
      this.registerForm.addControl(
        'password', new FormControl(''));

      for (let key of Object.keys(this.params.user)) {
        if (this.registerForm.controls[key]) {
          this.registerForm.controls[key].setValue(this.params.user[key]);
        }
      }
    } else {
      this.registerForm.addControl(
        'password', new FormControl('', Validators.required));
      this.service.generatePW().subscribe((res) => {
        this.registerForm.controls.password.setValue(res[0]);
      },(err) => {
        console.log(err);
  //      this.parent.toasterService.pop("error","テナントコード生成失敗");
      });  
    }
  }

  public onSubmit() {
    if (this.registerForm.invalid) {
      return;
    }
    const parameter = Object.assign({
      tenantCd : this.params.tenantCd
    }, this.registerForm.value);
    if (this.scope.isEdit) {
      this.service.update(this.params.user.id, parameter).subscribe(
        () => this.matDialogRef.close('SUCCESS'),
        (err) => {
          this.scope.message = err;
      });
    } else {
      this.service.create(parameter).subscribe(
        () => this.matDialogRef.close('SUCCESS'),
        (err) => {
          this.scope.message = err;
      });
    }
  }


  get f() {
    return this.registerForm;
  }


}
